import React from 'react';
import { Modal, Button } from 'antd';
import AjaxRequest from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import CrfTable from './CrfTable';
import '../style/list.less';

class Crf extends React.Component {
    state = {
        pagination: {
            pageSize: 10,
            current: 1,
        },
        searchParams: {},
        loading: false,
        controllers: [],
        tableColumns: [],
        tableDatas: [],
        visible: false,
    }
    
    show = (patientUserId) => {
        this.setState({
            visible: true,
            tableDatas: [],
            searchParams: { patientUserId },
        }, () => {
            this.loadData();
        })
    }

    hide = () => {
        this.setState({ visible: false }, () => {
            const { parentRender = false } = this.state;
            parentRender && this.props.loadData();
        });
    }

    loadData = (parentRender) => {
        const { typeName, visitGroupingId } = this.props;
        const { searchParams } = this.state;
        this.setState({ loading: true });

        const options = {
            url: API_URL.execute.list,
            data: {
                typeName,
                isAgain: 1,
                visitGroupingId,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: data => {
                const { controllers = [], tableColumns = [] } = data.data.tree.data;
                if(tableColumns[0]){
                    tableColumns[0]["fixed"] = "left";
                }
                const opcolumn = {
                    moduleDefineCode: 'op',
                    moduleDefineName: '操作',
                    criteriaDataType: 'TEXT',
                    isShow: 1,
                };
                if (tableColumns.length > 0) {
                    tableColumns.unshift(opcolumn);
                }
                this.setState({
                    controllers,
                    tableColumns,
                    loading: false,
                    tableDatas: data.data.datas,
                    parentRender: !!parentRender,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        AjaxRequest.sendRequest(options);
    }

    render() {
        const { typeName, visitGroupingId, canEditByInvStatus } = this.props;
        const { visible, loading, tableColumns, tableDatas, controllers } = this.state;
        return (
            <Modal
            title={`${typeName == 'Type_Filter' ? '筛选' : '预筛'}历史`}
            visible={visible}
            onCancel={this.hide}
            className="preview-modal"
            wrapClassName="vertical-center-modal"
            width="1000px"
            footer={<Button onClick={this.hide}>关闭</Button>}
        >
            <div className="execute-crf" style={{ padding: 20 }}>
                <CrfTable
                    controllers={controllers}
                    tableColumns={tableColumns}
                    tableDatas={tableDatas}
                    typeName={typeName}
                    ref={el => this.crfTableRef = el}
                    loading={loading}
                    loadData={this.loadData}
                    changeTabs={this.onChange}
                    visitGroupingId={visitGroupingId}
                    canEditByInvStatus={canEditByInvStatus}
                />
            </div>
        </Modal>
        );
    }
}

export default Crf;



// WEBPACK FOOTER //
// ./src/components/execute/crfHistory/index.js